import {
  apiRoutes,
  type DefaultQueryError,
  httpClient,
  type ItemTrend,
  type ItemTrends,
  type ParamsSuggestionItemTrend,
} from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

export const getSuggestionItemTrendListFn = async (
  params: ParamsSuggestionItemTrend
) => {
  const response = await httpClient.get<ItemTrends>(
    apiRoutes.insurance.item.suggestion,
    {
      params: params,
    }
  );
  return response.data;
};

export const useGetSuggestionItemTrend = (
  params: ParamsSuggestionItemTrend,
  opts?: UseQueryOptions<ItemTrend[], DefaultQueryError>
) =>
  useQuery<ItemTrend[], DefaultQueryError>({
    queryKey: [apiRoutes.insurance.item.suggestion, params],
    queryFn: () => getSuggestionItemTrendListFn(params),
    ...opts,
  });
